import React, { useState } from "react";
import { Link } from "react-router-dom";
import categories from "../utils/Categories";
import { Hammer, Search, X, SearchX } from "lucide-react";

const Materials = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const user = JSON.parse(localStorage.getItem("user"));

  const filteredCategories = categories.filter((item) =>
    item.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="pt-6 pb-10 px-4 md:px-6 bg-gray-50 dark:bg-gray-900 transition-all duration-300">
      <h2 className="text-xl md:text-3xl font-extrabold text-center mb-6 text-gray-800 dark:text-white tracking-wide flex items-center justify-center gap-2">
        <Hammer className="w-6 h-6 md:w-8 md:h-8 text-blue-600 dark:text-blue-400" />
        Explore Construction Categories
      </h2>

      {/* Search Bar — aligned with grid */}
      <div className="max-w-6xl mx-auto mb-8">
        <div className="relative max-w-md mx-auto">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 dark:text-gray-500" />
          <input
            type="text"
            placeholder="Search materials..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full pl-10 pr-10 py-2.5 text-sm border border-gray-200 dark:border-gray-600 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-800 dark:text-white transition-all duration-200"
          />
          {searchTerm && (
            <button
              onClick={() => setSearchTerm("")}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-red-500 transition-colors"
            >
              <X className="w-4 h-4" />
            </button>
          )}
        </div>
      </div>

      {/* Material Cards */}
      {filteredCategories.length > 0 ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 max-w-6xl mx-auto">
          {filteredCategories.map((item, idx) => {
            const linkPath =
              user?.role === "customer"
                ? `/customer/category/${encodeURIComponent(item.name)}`
                : `/category/${encodeURIComponent(item.name)}`;

            return (
              <Link
                key={idx}
                to={linkPath}
                className="bg-white dark:bg-gray-800 shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1 px-6 pt-6 pb-3 rounded-xl cursor-pointer flex flex-col group"
              >
                <div className="h-40 overflow-hidden rounded-lg border border-gray-100 dark:border-gray-700 mb-3 transition-transform duration-300 group-hover:scale-[1.02]">
                  <img
                    src={`${process.env.PUBLIC_URL}/categories/${item.name.toLowerCase()}.jpg`}
                    alt={item.name}
                    onError={(e) =>
                      (e.target.src = `${process.env.PUBLIC_URL}/categories/default.jpg`)
                    }
                    className="w-full h-full object-cover rounded-lg"
                  />
                </div>
                <h3 className="text-lg font-bold text-gray-800 dark:text-white tracking-wide mb-1">
                  {item.name}
                </h3>
                {user && (
                  <p className="text-xs text-gray-500 dark:text-gray-400 italic mb-1 truncate">
                    Tap to explore products under {item.name}
                  </p>
                )}
              </Link>
            );
          })}
        </div>
      ) : (
        <div className="flex flex-col items-center justify-center gap-3 text-gray-400 dark:text-gray-500 mt-16">
          <SearchX className="w-12 h-12" />
          <p className="text-lg font-semibold">No materials found</p>
          <p className="text-sm">Try a different search term</p>
        </div>
      )}
    </div>
  );
};

export default Materials;
